import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { wsPayloadResponse } from '../user/payload';
import { tap, catchError, map } from 'rxjs/operators';
import { PlugpointEnvironment } from '../PlugpointEnvironment';
import { VendorInfo } from './vendorInfo';
import { Guid } from 'guid-typescript';
import { LogService } from '../logs/log.service';
import { ActivityLog } from '../logs/log';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Basic NGhNVVh4a1pYYUN1amZ1NTphQXM1VnFHUyszWXZFRiN0' })
};

@Injectable()
export class DealerService {



    private url = '';

    private token = Guid.create().toString();
    public guid = true;
    vendorMap: Map<string, string> = new Map();
    constructor(
        public http: HttpClient,
        private logService: LogService,
    ) {
        this.url = PlugpointEnvironment.endpoint;
    }
    private getGatewayAuthHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            SessionId: Guid.create().toString()
        });
    }
    getOwner(vendorName: string, token: string): Observable<any> {
        return this.http.get<any>(PlugpointEnvironment.url + "/gateway/api/owner/" + vendorName, { headers: this.getGatewayAuthHeaders() }).pipe(
            catchError(this.handleError<any>()));
    }

    getOwnerInvoices(vendorName: string, month, year, token: string): Observable<any> {
        let body = {
            "month": month,
            "year": year
        }
        return this.http.post<any>(PlugpointEnvironment.url + "/gateway/api/owner/" + vendorName + '/invoices', body, { headers: this.getGatewayAuthHeaders() }).pipe(
            catchError(this.handleError<any>()));
    }
    getOwnerSessions(vendorName: string, month, year): Observable<any> {
        let body = {
            "month": month,
            "year": year
        }
        return this.http.post<any>(PlugpointEnvironment.url + "/gateway/api/owner/" + vendorName + '/sessions', body, { headers: this.getGatewayAuthHeaders() }).pipe(
            catchError(this.handleError<any>()));
    }

    getDealer(vendorName: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/dealer/${vendorName}`;
        return this.http.get<any>(url, { headers: this.getGatewayAuthHeaders() });
    }
    updateOwnerEmail(vendorName: string, email: string): Observable<any> {
        let body = {
            "accountingEmail": email,
        }
        return this.http.put<any>(PlugpointEnvironment.url + "/gateway/api/owner/" + vendorName, body, { headers: this.getGatewayAuthHeaders() }).pipe(
            catchError(this.handleError<wsPayloadResponse>()));
    }

    /*
        * not used ANYWHERE
    */
    addClient(dealerName: string, clientName: string): Observable<wsPayloadResponse> {
        if (this.guid == true) {
            this.token = Guid.create().toString();
        }
        let data = {
            "addFranchised": {
                "franchised": dealerName,
                "client": clientName
            }
        }
        var encodedData = btoa(JSON.stringify(data));
        let body = {
            "token": this.token,
            "action": "franchiseData",
            "data": encodedData
        }
        return this.http.post<wsPayloadResponse>(this.url, body, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }

    /*
        * not used ANYWHERE
    */
    deleteClient(id: number): Observable<wsPayloadResponse> {
        if (this.guid == true) {
            this.token = Guid.create().toString();
        }
        let data = {
            "deleteFranchised": {
                "franchiseDataId": id
            }
        }
        var encodedData = btoa(JSON.stringify(data));
        let body = {
            "token": this.token,
            "action": "franchiseData",
            "data": encodedData
        }
        return this.http.post<wsPayloadResponse>(this.url, body, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }

    getVendor(vendorName: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/vendor/${vendorName}`;
        return this.http.get<any>(url, { headers: this.getGatewayAuthHeaders() });
    }

    getAllVendorInvoices(startDate: string, endDate: string, token: string): Observable<any> {
        let url = new URL(PlugpointEnvironment.url + "/gateway/api/fleet/get-fleet-vendor-invoice")
        url.searchParams.append('startDate', startDate)
        url.searchParams.append('endDate', endDate)
        url.searchParams.append('vendor', '')
        return this.http.get<any>(url.toString(), { headers: this.getGatewayAuthHeaders() });
    }

    getVendorInvoice(vendorName: string, month: string, year: string, token: string): Observable<any> {
        let url = new URL(PlugpointEnvironment.url + "/helios/fleet/get-invoice-data")
        url.searchParams.append('vendor', vendorName)
        url.searchParams.append('month', month)
        url.searchParams.append('year', year)
        return this.http.get<any>(url.toString(), { headers: this.getGatewayAuthHeaders() });
    }

    async generateVendorInvoice(vendorName: string, users: number): Promise<any> {
        let url = new URL(PlugpointEnvironment.url + "/gateway/api/fleet/vendor/generate-oblio-invoice")
        url.searchParams.append('vendor', vendorName)
        url.searchParams.append('activeUsers', users.toString())

        return this.http.get<any>(url.toString(), { headers: this.getGatewayAuthHeaders() }).toPromise()
    }


    getVendorPJ(vendorName: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/vendor/info/${vendorName}`;
        return this.http.get<any>(url, { headers: this.getGatewayAuthHeaders() });
    }

    addVendor(dealerName: string, vendorInfoObj: VendorInfo, publicSubscription: boolean, userId: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/vendor/add`;
        const body = {
                vendorName: vendorInfoObj.vendorName,
                vendorFullName: vendorInfoObj.vendorFullName,
                vendorCIF: vendorInfoObj.vendorCIF,
                vendorAddress: vendorInfoObj.vendorAddress,
                invoiceSeries: 'spf',
                invoiceNumber: 1,
                tableSeries: 'ts',
                invoiceSeriesPJ: 'spj',
                invoiceNumberPJ: 1,
                tableSeriesPJ: 'ts',
                addedBy: dealerName,
                invoiceVAT: 19,
                contract: '',
                email: vendorInfoObj.email,
        };
        if (publicSubscription) {
            body['subscriptionCost'] = +vendorInfoObj.subscriptionCost;
            body['privateFleetContractNo'] = vendorInfoObj.privateContractNumber;
            body['publicFleetContractNo'] = vendorInfoObj.publicContractNumber;
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    /*
        * not used
    */
    addVendorNew(vendorObj): Observable<any> {

        if (this.guid == true) {
            var token = Guid.create().toString();
        }

        const httpOptionsLocal = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==', 'SessionID': token })
        }

        return this.http.post<any>(PlugpointEnvironment.url + "/invoice/owner/add", vendorObj, httpOptionsLocal)
    }

    getAllTags(): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/vendor-tags`;
        return this.http.get<any>(url, { headers: this.getGatewayAuthHeaders() });
    }

    /*
        * not used ANYWHERE
    */
    getTagsByVendor(vendorGroup: string): Observable<wsPayloadResponse> {
        if (this.guid == true) {
            this.token = Guid.create().toString();
        }
        let data = {
            "getTagIdData": {
                "vendorGroup": vendorGroup
            }
        }
        var encodedData = btoa(JSON.stringify(data));
        let body = {
            "token": this.token,
            "action": "additionalCalls",
            "data": encodedData
        }
        return this.http.post<wsPayloadResponse>(this.url, body, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }

    addTag(tagId: string, userId: number, vendorGroup: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/vendor-tags/add`;
        const body = {
            tagId: tagId,
            userId: userId,
            vendorGroup: vendorGroup,
            userGroup: "none"
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });

    }

    deleteTag(tagId: string, userId: number, vendorGroup: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/vendor-tags/delete`;
        const body = {
            tagId: tagId,
            userId: userId,
            vendorGroup: vendorGroup,
            userGroup: "none"
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    getAllVendorsFromGroup(userName:string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/vendor-group`;
        const body = {
                vendorGroup: "all",
                userName: userName

        };
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    /*
        * not used in dashboard, only uses the getAllBendorsFromGroup
    */
    getVendorsFromGroup(vendorGroup: string): Observable<wsPayloadResponse> {
        if (this.guid == true) {
            this.token = Guid.create().toString();
        }
        let data = {
            "getVendorGroup": {
                "vendorGroup": vendorGroup
            }
        }
        var encodedData = btoa(JSON.stringify(data));
        let body = {
            "token": this.token,
            "action": "additionalCalls",
            "data": encodedData
        }
        return this.http.post<wsPayloadResponse>(this.url, body, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }

    addVendorGroup(vendorGroup: string, stationVendor: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/vendor-groups/add`;
        const body = {
            vendorGroup: vendorGroup,
            stationVendor: stationVendor
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }
    deleteVendorGroup(vendorGroup: string, stationVendor: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/vendor-groups/delete`;
        const body = {
            vendorGroup: vendorGroup,
            stationVendor: stationVendor
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }
    populateVendorMap(): void {
        this.getVendorPJ('all').subscribe((res: any) => {
            res.data.forEach((vendor: any) => {
                this.vendorMap.set(vendor.vendorName, vendor.vendorFullName);
            });
        });
    }

    checkVendorName(vendorId: string): string {
        return this.vendorMap.get(vendorId) || vendorId;
    }


    /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            // console.error(error); // log to console instead


            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
interface BillingData {
    companyName: string;
    vatNumber: string;
    address: string;
}

interface OwnerInvoiceCounter {
    currentValue: number;
}

export interface NewVendorObj {
    evseOwner: string;
    ownerBillingData: BillingData;
    email: string;
    accountingEmail: string;
    invoiceSeries: string;
    contractNumber: string;
    ownerInvoiceCounter: OwnerInvoiceCounter;
}
